import React from 'react';
import { LegendPopover } from './components/LegendPopover';
import { Sidebar, SidebarSection, SidebarItem, SidebarLink, SidebarButton } from './components/Sidebar';
import { GuideModal } from './components/GuideModal';
import { Logout } from './components/Logout';
import { User } from './components/User';
import { NotificationsIconElement, NotificationsDrawer } from './components/Notifications';
import { useTranslation } from 'react-i18next';
import { FileIcon, GearIcon, HeartPulseIcon, IndustryWindowsSolidFilledIcon } from '@/assets/Icons';
import { Icon } from '@/components/shared/display/Icon';

export const AppSidebar = () => {
  const { t } = useTranslation();
  return (
    <div className="fixed top-header z-50">
      <Sidebar>
        <SidebarSection>
          <SidebarItem
            wrapper={SidebarLink}
            item={{
              element: () => <Icon icon={IndustryWindowsSolidFilledIcon} className="mb-0.5 w-7 h-7" />,
              label: t('sidebar.sites'),
              url: '/sites',
            }}
          />
          <SidebarItem
            wrapper={LegendPopover}
            item={{
              element: () => <Icon icon={HeartPulseIcon} className="-mb-0.5" />,
              label: t('sidebar.status'),
            }}
          />
          <SidebarItem
            wrapper={NotificationsDrawer}
            item={{
              element: NotificationsIconElement,
              label: t('sidebar.alerts'),
            }}
          />
          <SidebarItem
            wrapper={GuideModal}
            item={{
              element: () => <Icon icon={FileIcon} className="mb-0.5 w-7 h-7" />,
              label: t('sidebar.guide'),
            }}
          />
          <SidebarItem
            wrapper={SidebarLink}
            item={{
              element: () => <Icon icon={GearIcon} className="mb-0.5 w-7 h-7" />,
              label: t('sidebar.settings'),
              url: '/settings',
            }}
          />
        </SidebarSection>
        <SidebarSection>
          <SidebarButton
            wrapper={SidebarLink}
            item={{
              element: () => <User />,
              url: '/settings',
            }}
          />
          <SidebarButton
            wrapper={Logout}
            item={{
              label: t('sidebar.logout'),
            }}
          />
        </SidebarSection>
      </Sidebar>
    </div>
  );
};
